export interface ChecklistDTO {
  job_id: string
  sections: SectionDTO[]
}

export interface SectionDTO {
  id: string
  name: string
  heading: string
  description: string
  requested_supporting_items: RequestedSupportingItemDTO[]
}

export interface RequestedSupportingItemDTO {
  id: string
  name: string
  heading: string
  short_description: string
  long_description: string
  image_url?: string
  preview_url?: string
  required: boolean
  adHoc: boolean
  completed: boolean
  update_time: string | undefined
  input: SupportingItemInputDTO
}

export interface SupportingItemInputDTO {
  type: SupportingItemInputTypeDTO
}

export type SupportingItemInputTypeDTO =
  | DocumentSupportingItemInputTypeDTO
  | PersonalInfoSupportingItemInputTypeDTO
  | SpousalInfoSupportingItemInputTypeDTO
  | DependentsInfoSupportingItemInputTypeDTO
  | PersonalRefundMethodInfoSupportingItemInputTypeDTO
  | BusinessInfoSupportingItemInputTypeDTO
  | BusinessRefundMethodInfoSupportingItemInputTypeDTO
  | NotesSupportingItemInputTypeDTO

export interface DocumentSupportingItemInputTypeDTO {
  // Just to make the mapping easier, I miss C# :(
  discriminator: SupportingItemInputTypeDiscriminatorDTO.DOCUMENT
  document: {
    document_type_short_id: string
    document_long_ids: string[]
  }
}

export interface PersonalInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.PERSONAL_INFO
  personal_info: {
    profile_id?: string
    profile_version?: number
  }
}

export interface SpousalInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.SPOUSAL_INFO
  spousal_info: {
    profile_id?: string
    profile_version?: number
  }
}

export interface DependentsInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.DEPENDENTS_INFO
  dependents: Array<{
    profile_id?: string
    profile_version?: number
  }>
}

export interface PersonalRefundMethodInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.PERSONAL_REFUND_METHOD_INFO
  personal_refund_method_info: {
    refund_method_id?: string
    refund_method_version?: number
  }
}

export interface BusinessInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.BUSINESS_INFO
  business_info: {
    profile_id?: string
    profile_version?: number
  }
}

export interface BusinessRefundMethodInfoSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.BUSINESS_REFUND_METHOD_INFO
  business_refund_method_info: {
    refund_method_id?: string
    refund_method_version?: number
  }
}

export interface NotesSupportingItemInputTypeDTO {
  discriminator: SupportingItemInputTypeDiscriminatorDTO.NOTES
  notes: {
    text?: string
  }
}

export enum SupportingItemInputTypeDiscriminatorDTO {
  DOCUMENT,
  PERSONAL_INFO,
  SPOUSAL_INFO,
  DEPENDENTS_INFO,
  PERSONAL_REFUND_METHOD_INFO,
  BUSINESS_INFO,
  BUSINESS_REFUND_METHOD_INFO,
  NOTES,
}
